import { render, staticRenderFns } from "./twoStar.vue?vue&type=template&id=90d929d2&scoped=true"
import script from "./twoStar.vue?vue&type=script&lang=js"
export * from "./twoStar.vue?vue&type=script&lang=js"
import style0 from "./twoStar.vue?vue&type=style&index=0&id=90d929d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d929d2",
  null
  
)

export default component.exports